export const hasDiscount = (price: number, regPrice: number): boolean => {
  return price ? price < regPrice : false;
};
